import { render, staticRenderFns } from "./productDetailSeckillOrder.vue?vue&type=template&id=2b4e85b5&scoped=true"
import script from "./productDetailSeckillOrder.vue?vue&type=script&lang=js"
export * from "./productDetailSeckillOrder.vue?vue&type=script&lang=js"
import style0 from "./productDetailSeckillOrder.vue?vue&type=style&index=0&id=2b4e85b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4e85b5",
  null
  
)

export default component.exports